export default __webpack_public_path__ + "static/media/misc-closetA-480w.3b9bae38.avif";